import { sendPostMessage } from '@/azure/postMessage/sender';
import { REMOVE_SPINNER } from '@/azure/postMessage/types';
import { getParentDomain } from '@/azure/postMessage/urls';

const ERROR_CSS_CLASS = 'highlightError';

const ERRORS = [
  {
    message: "We can't seem to find your account",
    fieldId: 'signInName',
  },
  {
    message: 'Your password is incorrect',
    fieldId: 'password',
  },
  {
    message: 'Missing required element: Country',
    fieldId: 'combinedLocation',
  },
  {
    message: 'The password entry fields do not match',
    fieldId: 'newPassword',
  },
  {
    message: 'A user with the specified e-mail address already exists',
    fieldId: 'email',
  },
];

const mapErrorFieldByErrorMessage = (errorMessage) => {
  const errorField = ERRORS.filter((error) => errorMessage.includes(error.message));
  return errorField[0]?.fieldId;
};

const createPageErrorFieldMutationObserver = (errorField: HTMLElement) =>
  new MutationObserver(() => {
    ERRORS.forEach((error) => {
      const field = document.getElementById(error.fieldId);
      if (field) {
        field.classList.remove(ERROR_CSS_CLASS);
      }
    });
    if (errorField.style.display !== 'none') {
      const errorFieldId = mapErrorFieldByErrorMessage(errorField.innerText);
      const newErrorField = document.getElementById(errorFieldId);

      if (errorFieldId && newErrorField) {
        newErrorField.classList.add(ERROR_CSS_CLASS);
      }
    }
  });

const createErrorMutationObserver = (errorField: HTMLElement) =>
  new MutationObserver(() => {
    if (errorField && errorField.style.display !== 'none') {
      sendPostMessage({ id: REMOVE_SPINNER }, getParentDomain(window.location.href) || '');
    }
  });

export const initErrorHandler = (): void => {
  document.querySelectorAll<HTMLElement>('.error.pageLevel').forEach((errorField) => {
    createPageErrorFieldMutationObserver(errorField).observe(errorField, { attributes: true, childList: true });
  });
  document.querySelectorAll<HTMLElement>('.error').forEach((errorField) => {
    createErrorMutationObserver(errorField).observe(errorField, { attributes: true, childList: true });
  });
};
